import AuditList from "./AuditList";


function AuditListUser () {

    return (
        <AuditList adminMode={false} />
    )
}

export default AuditListUser;